import React from 'react';
import './AboutPage.css';

const ABOUT_IMAGE = 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1200&q=80';

const AboutPage = () => {

  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1 className="about-hero-title">İso Belgesi Hakkında</h1>
          <p className="about-hero-subtitle">
            İSO belgeleri ve kalite yönetim sistemi danışmanlığında güvenilir adres
          </p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <div className="about-intro-image">
            <img src={ABOUT_IMAGE} alt="" />
          </div>
          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Hikayemiz</h2>
              <div className="section-content">
                <p>
                  İso Belgesi olarak, İSO belgeleri ve kalite yönetim sistemi danışmanlığı 
                  alanında deneyim ve uzmanlıkla hizmet vermekteyiz. ISO 9001, ISO 14001, ISO 22000, 
                  ISO 27001 ve diğer İSO standartlarında belgelendirme süreçlerinde işletmelerin yanındayız.
                </p>
                <p>
                  Müşteri memnuniyetini ön planda tutan anlayışımızla, KOBİ'lerden büyük ölçekli 
                  firmalara kadar geniş bir portföye İSO hazırlık, dokümantasyon ve denetim 
                  süreçlerinde danışmanlık sunuyoruz.
                </p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="mission-vision-container">
              <div className="mission-vision-item">
                <h2 className="section-title">Misyonumuz</h2>
                <div className="section-content">
                  <p>
                    Misyonumuz, İSO belgeleri ve kalite yönetim sistemleri alanında güvenilir 
                    danışmanlık sunarak işletmelerin belgelendirme süreçlerini kolaylaştırmak ve 
                    uluslararası standartlara uyumlarını sağlamaktır.
                  </p>
                  <p>
                    Müşterilerimize ISO 9001, 14001, 22000, 27001 ve diğer İSO standartlarında 
                    hazırlık, dokümantasyon ve denetim süreçlerinde en uygun koşullarla destek 
                    vermek temel hedefimizdir.
                  </p>
                </div>
              </div>
              <div className="mission-vision-item">
                <h2 className="section-title">Vizyonumuz</h2>
                <div className="section-content">
                  <p>
                    Vizyonumuz, İSO belgeleri ve kalite yönetim sistemi danışmanlığında Türkiye'nin 
                    önde gelen referanslarından biri olmak. İşletmelerin kalite, çevre, gıda ve bilgi 
                    güvenliği standartlarına uyum süreçlerinde güvenilir çözüm ortağı olmaya devam etmek.
                  </p>
                  <p>
                    İSO standartlarındaki güncellemeleri takip ederek, müşterilerimizi güncel gerekliliklere 
                    göre yönlendiriyor ve belgelendirme süreçlerinde sürdürülebilir destek sunuyoruz.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Değerlerimiz</h2>
              <div className="values-grid">
              <div className="value-card">
                <h3>Kalite</h3>
                <p>
                  İSO standartlarına uygun danışmanlık sunuyor, belgelendirme süreçlerinde 
                  en yüksek kalite ve güncellikte bilgi sağlıyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Güvenilirlik</h3>
                <p>
                  Verdiğimiz sözleri tutuyor; dokümantasyon, hazırlık ve denetim süreçlerinde 
                  zamanında ve güvenilir hizmet sunuyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Standartlara Uyum</h3>
                <p>
                  ISO 9001, 14001, 22000, 27001 ve diğer standartlarda güncel gerekliliklere 
                  uygun rehberlik sağlıyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Müşteri Odaklılık</h3>
                <p>
                  Her işletmenin sektörüne ve ihtiyacına göre özel İSO danışmanlığı 
                  ve belgelendirme desteği sunuyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Güncel Bilgi</h3>
                <p>
                  İSO standartlarındaki revizyon ve güncellemeleri takip ederek 
                  müşterilerimizi yönlendiriyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Şeffaflık</h3>
                <p>
                  Süreçler, süreler ve maliyetler konusunda net ve şeffaf 
                  iletişim kuruyoruz.
                </p>
              </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Hizmet Sürecimiz</h2>
              <div className="section-content">
                <p>
                  İSO belgelendirme süreçlerinde profesyonel ekibimiz ve deneyimimizle 
                  yanınızdayız. İhtiyaç analizinden belge alımına kadar her aşamada rehberlik sunuyoruz.
                </p>
              </div>
              <div className="process-steps">
                <div className="process-step">
                  <div className="step-number">1</div>
                  <h3>İhtiyaç Analizi</h3>
                  <p>
                    İşletmenizin sektörü ve hedeflerine göre uygun İSO standardı belirlenir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">2</div>
                  <h3>Mevcut Durum Değerlendirmesi</h3>
                  <p>
                    Mevcut süreçler ve dokümanlar incelenir, boşluk analizi yapılır.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">3</div>
                  <h3>Dokümantasyon Hazırlığı</h3>
                  <p>
                    Politika, prosedür ve talimatlar standartlara uygun hazırlanır.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">4</div>
                  <h3>Uygulama Desteği</h3>
                  <p>
                    Sistemin uygulanması ve iç denetim süreçlerinde danışmanlık verilir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">5</div>
                  <h3>Denetim Öncesi Hazırlık</h3>
                  <p>
                    Belgelendirme kuruluşu denetimine hazırlık ve mock denetim yapılır.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">6</div>
                  <h3>Belge Sonrası Destek</h3>
                  <p>
                    Belge alındıktan sonra gözetim denetimleri ve güncellemelerde destek sunulur.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Neden Bizi Seçmelisiniz?</h2>
              <div className="why-choose-grid">
              <div className="why-choose-card">
                <h3>Geniş İSO Yelpazesi</h3>
                <p>
                  ISO 9001, 14001, 22000, 27001 ve diğer İSO standartlarında danışmanlık ve belgelendirme desteği.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Sektöre Özel Danışmanlık</h3>
                <p>
                  Her işletmenin sektörüne ve büyüklüğüne uygun İSO hazırlık ve dokümantasyon çözümleri.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Deneyimli Ekip</h3>
                <p>
                  Kalite yönetim sistemleri ve belgelendirme süreçlerinde deneyimli danışman kadromuz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Şeffaf Süreç</h3>
                <p>
                  Süre ve maliyetler konusunda net bilgilendirme, adım adım takip.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Güncel Standartlar</h3>
                <p>
                  İSO revizyonlarını takip ederek güncel gerekliliklere göre yönlendirme.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Belge Sonrası Destek</h3>
                <p>
                  Belge aldıktan sonra gözetim denetimleri ve sürdürülebilirlik konusunda destek.
                </p>
              </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
